module.exports = __webpack_public_path__ + "img/worksbot_img19112537.139c725b.jpg";